import { useFlag } from '@acre/utils'

// Single source for the Helmet titleTemplate so every page-level Helmet
// switches brand with the rebrand flag together with the app shell's template.
export const useBrandedTitleTemplate = () => {
  const isScoreRebrand = useFlag('feature.score_rebrand', false)

  return isScoreRebrand ? 'Score. Broker CRM | %s' : 'Acre Broker CRM | %s'
}

// Brand name for hardcoded (non-i18n) copy that references the product by name.
export const useBrandName = () => {
  const isScoreRebrand = useFlag('feature.score_rebrand', false)

  return isScoreRebrand ? 'Score.' : 'Acre'
}
